import React, { useState } from "react";
import { Check, ChevronRight, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { sendContactEmail } from "../lib/emailjs";

interface HeroFormProps {
  title: string;
  description: string;
}

function HeroForm({ title, description }: HeroFormProps) {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<{
    success?: boolean;
    message?: string;
  }>({});

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "", // Add this line
    category: "",
    description: "",
  });

  const handleBlur = () => {
    const hasValue = Object.values(formData).some((val) => val.trim() !== "");
    if (!hasValue) {
      setIsExpanded(false);
    }
  };

  const isFormValid = () => {
    return Object.values(formData).every((value) => value.trim() !== "");
  };

  const handleInputChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const hasValue = Object.values({ ...formData, [name]: value }).some(
      (val) => val !== ""
    );
    setIsExpanded(hasValue);
  };

  const handleFocus = () => {
    setIsExpanded(true);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus({});

    try {
      const result = await sendContactEmail(formData);
      if (result?.success) {
        setFormData({
          name: "",
          email: "",
          phone: "",
          category: "",
          description: "",
        });
        setIsExpanded(false);
        navigate("/bedankt-offerte");
      } else {
        setSubmitStatus({
          success: false,
          message:
            result.error ||
            "Er is iets misgegaan. Probeer het later opnieuw of neem telefonisch contact op.",
        });
      }
    } catch (error) {
      setSubmitStatus({
        success: false,
        message:
          "Er is iets misgegaan. Probeer het later opnieuw of neem telefonisch contact op.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="bg-white w-full relative border border-solid border-shade100 rounded-xl max-w-[448px] overflow-visible py-7 px-6"
      id="offer"
    >
      <form onSubmit={handleSubmit}>
        <div>
          <h1 className="sr-only">{title}</h1>

          <h2 className="font-bold text-black leading-[1.25] text-[28px] lg:text-[36px] text-[#17354A] block mb-4 leading-[35px] text-[2rem] md:inline-block md:mb-5 md:text-[44px] md:leading-[42px] lg:block">
            {title}
          </h2>
          <div className="text-black leading-[1.56] text-[16px] md:text-[18px] font-normal text-[#17354A] mb-3">
            {description}
          </div>
          <ul className="space-y-3 font-medium text-black mb-6">
              <li className="flex text-xs items-center gap-1">
                <Check className="w-4 h-4 text-[#F47B20]" />
                <span className="">
                Altijd een vakbekwame elektricien beschikbaar
                </span>
              </li>
              <li className="flex text-xs items-center gap-1">
                <Check className="w-4 h-4 text-[#F47B20]" />
                <span className="">
                Complete elektrische diensten voor elke situatie
                </span>
              </li>
              <li className="flex text-xs items-center gap-1">
                <Check className="w-4 h-4 text-[#F47B20]" />
                <span className="">
                Gecertificeerde en zegel gerechtigde elektriciens
                </span>
              </li>
             
            </ul>

        </div>

        <div className="relative">
          <div className="grid grid-cols-12 grid-rows-[repeat(3,_auto)] gap-y-3">
            <div className="col-span-12 transition-all duration-300">
              <a
                href="/offerte"
                className="bg-[#F47B20] text-white hover:bg-[#F47B20]/80 focus:bg-[#F47B20]/80 relative font-medium transition-all duration-150 leading-normal outline-none inline-flex border-2 border-transparent items-center justify-center rounded-full active:scale-[.98] text-base px-5 h-12 w-full"
              >
                Gratis offerte
              </a>
            </div>
            <div className="col-span-12 transition-all duration-300">
              <a
                href="tel:+31852129778"
                className="relative font-medium transition-all duration-150  outline-none inline-flex border-2 border-[#17354A] items-center justify-center rounded-full active:scale-[.98] disabled:cursor-not-allowed text-base px-5 h-12 leading-normal text-[#17354A] hover:bg-[#17354A] hover:text-white focus:opacity-60 w-full"
              >
                <span className="flex items-center gap-1">
                  <Phone className="w-4 h-4" />
                  085-2129778
                </span>
              </a>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default HeroForm;
